import { render, staticRenderFns } from "./CourseSubmitApplicationsFilterDropdown.vue?vue&type=template&id=43f584a6&"
import script from "./CourseSubmitApplicationsFilterDropdown.vue?vue&type=script&lang=ts&"
export * from "./CourseSubmitApplicationsFilterDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports